<template>
  <header class="page-header">
    <div class="toggle-button" @click="changeMobileMenuVisibility">
      <div class="toggle-button__bar"></div>
      <div class="toggle-button__bar"></div>
      <div class="toggle-button__bar"></div>
    </div>
    <Logo :imagePath="saleImage" v-scroll-to="setScrollSettings()" />
    <Navigation :id-blocks="['about', 'cars', 'servis', 'contacts']" />
    <Logo :imagePath="autoRepairImage" />
  </header>
</template>
<script>
import Logo from "./components/Logo";
import Navigation from "./components/Navigation";
import { mapMutations } from "vuex";

export default {
  components: {
    Logo,
    Navigation
  },
  data() {
    return {
      saleImage: require("../../../assets/ak-logo_mirror.png"),
      autoRepairImage: require("../../../assets/mb-logo.png")
    };
  },
  methods: {
    ...mapMutations(["changeMobileMenuVisibility"]),
    setScrollSettings() {
      return {
        el: "#news"
      };
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../scss/global.scss";

.page-header {
  position: fixed;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  top: 0;
  left: 0;
  background-color: #fff;
  padding: 0rem 1rem 0.1rem 1rem;
  z-index: 100;

  .toggle-button {
    position: absolute;
    left: 1rem;
    width: 2.8rem;
    background: transparent;
    border: none;
    cursor: pointer;
    padding-top: 0;
    padding-bottom: 0;
    vertical-align: middle;
  }

  .toggle-button:focus {
    outline: none;
  }

  .toggle-button__bar {
    width: 100%;
    height: 0.2rem;
    background: #474747;
    display: block;
    margin: 0.6rem 0;
  }
}

@media (min-width: $min-width-extended) {
  .page-header {
    position: sticky;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 1rem 0.1rem 1rem;
  }
  .toggle-button {
    display: none;
  }
}
</style>
